import React, { Component } from "react";
import { BrowserRouter, Redirect, Switch, Route } from 'react-router-dom';
import  InventoryPage  from "../../common/report/reports/inventory/inventory-page.component";
import  InventoryCircuit  from "./inventory-log/inventory-circuit.component";
import InventoryEquipment from "./inventory-log/inventory-equipment.component";
import InventoryAspu from "./inventory-log/inventory-aspu.component";
import InventoryAsr from "./inventory-log/inventory-asr.component";
import { connect } from 'react-redux';
import  {InventoryDetails}  from "./DetailsView/inventory-details-view.component";
import { HeaderFilter } from "../../common/header-filter/header-filter.component";
import { DataTable } from "../../common/table/data-table/data-table-component";
import { RequestHeaders } from "../../common/header-logo/request-header.component";
class InternalInventoryPageLayout extends Component {
    constructor(props) {
        super(props);
        this.state={
            showDetailPage:false,
            viewDetailPage:false,
            listSelected:"Circuit",
            tabSelected:0,
            selectedIndex: 0,
        }
    }
    displayDetailsView(show) {
        this.setState({showDetailPage:show})
    }

    getData=(value)=>{
        this.setState({viewDetailPage:value})
    }
    
    filterList=(value)=>{
        this.setState({listSelected:value})
    }

    tabSelected=(value)=>{
        this.setState({tabSelected:value})
    }

    FilterIndex=(value)=>{
        this.setState({selectedIndex:value})
    }
    render() {
        const dataTable=[
            {              
                HeaderItem:[
                    {
                        name:"Contract Name"
                    },
                    {
                        name:"Vendor"
                    }, {
                        name:"Status"
                    }, {
                        name:"Service Type"
                    }, {
                        name:"Effective Date"
                    }, {
                        name:"Expiration Date"
                    }
                ],
                dataItem:[{            
                    columnItem1:"3G Hutchison (GB) Contract",
                    columnItem2: "3G Hutchison (GB)",
                    columnItem3: "Expired",
                    columnItem5: "May 29, 2021",
                    columnItem6: "May 15, 2022",
                    columnItem7: "May 15, 2022",
                }, {            
                    columnItem1:"3G Hutchison (GB) Contract",
                    columnItem2: "3G Hutchison (GB)",
                    columnItem3: "Expired",
                    columnItem5: "May 29, 2021",
                    columnItem6: "May 15, 2022",
                    columnItem7: "May 15, 2022",
                },{            
                    columnItem1:"3G Hutchison (GB) Contract",
                    columnItem2: "3G Hutchison (GB)",
                    columnItem3: "Expired",
                    columnItem5: "May 29, 2021",
                    columnItem6: "May 15, 2022",
                    columnItem7: "May 15, 2022",
                },{            
                    columnItem1:"3G Hutchison (GB) Contract",
                    columnItem2: "3G Hutchison (GB)",
                    columnItem3: "Expired",
                    columnItem5: "May 29, 2021",
                    columnItem6: "May 15, 2022",
                    columnItem7: "May 15, 2022",
                }          
                ]

            }
        ]
        const pages={
            HasNext: true,
            HasPrevious: false,
            PageNumber: 0,
            PerPage: 21,
            TotalEntries: 2453,
            TotalPages: 123

        }
        const dropdownItem=["Item 1","Item 2", "Item 3"]
        const filterData = [
            {
                id:1,
                filterTitle:"Item 1",
                
            },
            {
                id:2,
                filterTitle:"Item 2",              
            },
            {
                id:3,
                filterTitle:"Item 3",              
            }, {       
                id:4,        
                filterTitle:"Item 4 with Checkbox",              
            }
        ];
        const listItem={
            Tab:[
                {
                    "id":"0",
                    "label":"Circuit"            
                },
                {
                    "id":"1",
                    "label":"Equipment"           
                },
                {
                    "id":"2",
                    "label":"ASPU"           
                },
                {
                    "id":"3",
                    "label":"ASR"           
                }
            ]
        };
       
        const filtersub=[
            {key:31,
            value:"Change Location Address"},
            {key:5,value:"Change Price Plan"},
            {key:4,value:"Change User"},
            {key:14,value:"Change Vendor"},
            {key:29,value:"Change Vendor"},
            {key:27,value:"New Circuit"},
            {key:9,value:"New Mobile Subscription"},
            {key:32,value:"Other"}];
        
        return(
           <>
            <RequestHeaders headerTitle="Rate Catalogue" />
                <div className="request-table data-table internal-data-table">
                        {
                            this.state.selectedIndex==0 && !this.state.viewDetailPage &&
                            <HeaderFilter enableDropdown={true} dropdownItem={dropdownItem} enableFilterBtn={true} filterData={filterData} 
                            filtersub={filtersub} enableAddBtn={false} enableExportExcel={true}
                            listSelected={this.state.listSelected} listItem={listItem.Tab} 
                            filterList={this.filterList} selectedIndex={this.state.selectedIndex}
                            FilterIndex={this.FilterIndex} enableUploadBtn={true} haveTab={true} />
                        }
                        {
                            this.state.selectedIndex==1 && !this.state.viewDetailPage &&
                            <HeaderFilter enableFilterBtn={true} filterData={filterData} 
                            filtersub={filtersub} enableAddBtn={true} btnAddTitle={`Add ${this.state.listSelected}`} 
                            listSelected={this.state.listSelected} listItem={listItem.Tab} 
                            filterList={this.filterList} selectedIndex={this.state.selectedIndex}
                            FilterIndex={this.FilterIndex}  haveTab={true} />
                        }
                        {
                            this.state.selectedIndex==2 && !this.state.viewDetailPage &&
                            <HeaderFilter enableExtractBtn={true}
                            filtersub={filtersub} listSelected={this.state.listSelected} listItem={listItem.Tab} 
                            filterList={this.filterList} selectedIndex={this.state.selectedIndex}
                            FilterIndex={this.FilterIndex}  haveTab={true} />
                        }
                        {
                            this.state.selectedIndex==3 && !this.state.viewDetailPage &&
                            <HeaderFilter enableExtractBtn={true}
                            filtersub={filtersub} listSelected={this.state.listSelected} listItem={listItem.Tab} 
                            filterList={this.filterList} selectedIndex={this.state.selectedIndex}
                            FilterIndex={this.FilterIndex}  haveTab={true} enableAddressBtn={true} />
                        }
                        
                        {
                            this.state.viewDetailPage &&
                            <InventoryDetails closeForm={this.getData.bind(this)} />
                        }

                        {!this.state.viewDetailPage && dataTable.map((item, id) =>
                            <DataTable key={id} id={id} item={item} header={item.HeaderItem} getData={this.getData} data={item.dataItem} customClassName="table-container" pages={pages} isDataLoaded={true} havePagination={true} />
                        )}
                </div>
            </>
        )   
    }
}

export default connect()(InternalInventoryPageLayout);